import React, {Suspense} from 'react';
import s from './App.module.css';
import logo from '../src/assets/img/logo.svg'
import whale from '../src/assets/img/whale.svg'
import telegramm from '../src/assets/img/telegramm.svg'
import x from '../src/assets/img/x.svg'
import mail from '../src/assets/img/mail.svg'
import gateBig from '../src/assets/img/gateBig.svg'
import bybitBig from '../src/assets/img/bybit_big.svg'
import frame2 from '../src/assets/img/Frame2.svg'
import telegrammBlack from '../src/assets/img/telegram_black.svg'
import BinanceBig from '../src/assets/img/binanceBig.svg'
import baselineTelegram from '../src/assets/img/baseline-telegram.svg'
import jupiter from '../src/assets/img/jupiter.svg'
import raydium from '../src/assets/img/raydium.svg'
import bybit from '../src/assets/img/bybit.svg'
import okx from '../src/assets/img/okx.svg'
import gate from '../src/assets/img/gate.svg'
import kucoin from '../src/assets/img/kucoin.svg'
import bitget from '../src/assets/img/bitget.svg'
import attention from '../src/assets/img/warning.svg'
import pump from '../src/assets/img/pump.svg'
import whitebit from '../src/assets/img/whitebit.svg'
import binance from '../src/assets/img/binance.svg'
import discord from '../src/assets/img/discord.svg'
import arrow from '../src/assets/img/arrow_up_line.svg'
import gecko from '../src/assets/img/geckoterminal.svg'
import dextools from '../src/assets/img/dextools.svg'
import dexsreener from '../src/assets/img/dexscreener.svg'
import coinmarket from '../src/assets/img/coinmarketcap.svg'
import {useTranslation} from "react-i18next";
import CustomDropdown from "./ui/CustomDropdown/CustomDropdown";
import {TFunction} from "i18next";
import TransparentButton from "./assets/components/TransparentButton/TransparentButton";

function App() {

    // @ts-ignore
    const { t }: TFunction<"translation", undefined> = useTranslation();

    return (
        <Suspense>
            <div className={s.app}>
                <div className={s.content_wrapper}>
                    <header className={s.header}>
                        <div>
                            <img src={logo} className={s.logo} alt="" loading="lazy"/>
                        </div>
                        <div>
                            <CustomDropdown/>
                        </div>
                        <div className={s.links_block}>
                            <button className={s.referal_button}>Referral program</button>
                            <div><a className={s.button} href="#contacts">
                                Contacts
                            </a></div>
                            <div><a className={s.button}
                                    href="#platform">How to buy
                            </a></div>
                        </div>
                    </header>

                    <header className={s.mobile_header}>
                        <div>
                            <img src={logo} className={s.logo} alt="" loading="lazy"/>
                        </div>
                        <div>
                            <CustomDropdown/>
                        </div>
                        <div className={s.links_block}>
                            <div><a className={s.button} href="#contacts">
                                Contacts
                            </a></div>
                            <div><a className={s.button}
                                    href="#platform">How to buy
                            </a></div>
                        </div>
                        <button className={s.referal_button}>Referral program</button>
                    </header>

                    <main className={s.main}>
                        <div className={s.text_block}>
                            <div className={s.title_block}>
                                <span className={s.title_one}>The Only Official</span> <br/>
                                <span className={s.title_two}>DeepSeek AI meme</span>
                            </div>
                            <div>
                                <a href="https://pump.fun/coin/ChDvobtSkd933iLfy7VbznWyY8saes2nfN5jkaLppump"
                                   target="_blank" className={s.button_wrapper}>
                                    <button className={s.my_btn}>Buy Now</button>
                                </a>
                            </div>
                            <div className={s.description_block}>
                                <span>
                                    <span className={s.bold}>Deep Seek AI </span>Coin {t("page.main description one")}
                                </span>
                                <br/>
                                <span>
                                    <span className={s.bold}>Deep Seek AI</span> Coin {t("page.main description two")}
                                </span>
                            </div>

                            <div className={s.smart_contract_block}>
                                <div className={s.attention}>
                                    <img src={attention} alt=""/>
                                </div>
                                <div className={s.smart_contract_text_block}>
                                    {t("page.smart contract one")}
                                    <span className={s.bold}>Deep Seek AI Coin</span>
                                    {t("page.smart contract two")}
                                    <span className={s.link}>
                                        <a href="https://pump.fun/coin/ChDvobtSkd933iLfy7VbznWyY8saes2nfN5jkaLppump">ChDvobtSkd933iLfy7VbznWyY8saes2nfN5jkaLppump</a>
                                    </span>
                                </div>
                            </div>

                            <div className={s.platforms_title} id={"platform"}>
                                You can also buy <span className={s.colorful}>Deep Seek AI Coin</span> on these
                                platforms:
                            </div>

                        </div>
                        <div className={s.img_block}>
                            <img className={s.whale} src={whale} alt="" loading="lazy"/>
                        </div>
                    </main>

                    <div className={s.platforms_buttons_block}>
                        <TransparentButton
                            platformImg={pump}
                            text={"Buy on Pump.fun"}
                            platformLink={"https://pump.fun/coin/ChDvobtSkd933iLfy7VbznWyY8saes2nfN5jkaLppump"}
                        />
                        <TransparentButton
                            platformImg={raydium}
                            text={"Buy on Raydium"}
                            platformLink={"https://raydium.io/swap/?inputMint=Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB&outputMint=ChDvobtSkd933iLfy7VbznWyY8saes2nfN5jkaLppump&referrer=yLWuQwY6pKbBGKd9UnRfh2hb6QVxyEmgmN7xedMVjUA"}
                        />
                        <TransparentButton
                            platformImg={jupiter}
                            text={"Buy on Jupiter"}
                            platformLink={"https://jup.ag/swap/USDT-ChDvobtSkd933iLfy7VbznWyY8saes2nfN5jkaLppump"}
                        />

                    </div>

                    <div className={`${s.platforms_buttons_block} ${s.direction}`}>
                        <TransparentButton
                            platformImg={bybit}
                            text={"Buy on Bybit"}
                            platformLink={"https://www.bybit.com/en/web3/dex/sol/ChDvobtSkd933iLfy7VbznWyY8saes2nfN5jkaLppump/"}
                        />
                        <TransparentButton
                            platformImg={okx}
                            text={"Buy on Okx"}
                            platformLink={"https://www.okx.com/ru/web3/detail/501/ChDvobtSkd933iLfy7VbznWyY8saes2nfN5jkaLppump"}
                        />
                        <TransparentButton
                            platformImg={gate}
                            text={"Buy on Gate.io"}
                            platformLink={"https://www.gate.io/web3/dextrade/solana/ChDvobtSkd933iLfy7VbznWyY8saes2nfN5jkaLppump"}
                        />
                    </div>

                    <div className={s.available}>
                        <span>Also available on: </span>
                        <span><img src={binance} alt=""/> Binance</span>
                        <span><img src={kucoin} alt=""/> KuCoin</span>
                        <span><img src={bitget} alt=""/> Bitget</span>
                        <span><img src={whitebit} alt=""/> WhiteBIT</span>
                    </div>

                    <div className={s.platforms_buttons_block}>
                        <div>
                            <a href="https://t.me/deepseekmain" target="_blank">
                                <img src={telegramm} alt=""/>
                            </a>
                        </div>
                        <div>
                            <a href="https://t.me/deepseekAIchat" target="_blank">
                                <img src={telegrammBlack} alt=""/>
                            </a>
                        </div>
                        <div>
                            <a href="https://x.com/deepseekmain" target="_blank">
                                <img src={x} alt=""/>
                            </a>
                        </div>
                        <div>
                            <a href="https://discord.gg/mbGTETvw" target="_blank">
                                <img src={discord} alt=""/>
                            </a>
                        </div>
                    </div>

                    <div className={s.features_block}>
                        <div className={s.features_title}>
                        <span className={s.title_one}>
                            {t("page.features title")}
                        </span> <br/>
                            <span className={s.title_two}>
                            Deep Seek AI Coin:
                        </span>
                        </div>

                        <div className={s.features_card_block}>

                            <div className={s.features_card_row}>
                                <div className={s.features_card}>
                                    <div className={s.title}>
                                        {t("page.feature one title")}
                                    </div>
                                    <div className={s.subtitle}>
                                        {t("page.feature one desc")}
                                    </div>
                                </div>
                                <div className={s.features_card}>
                                    <div className={s.title}>
                                        {t("page.feature two title")}
                                    </div>
                                    <div className={s.subtitle}>
                                        {t("page.feature two desc")}
                                    </div>
                                </div>
                            </div>

                            <div className={s.features_card_row}>
                                <div className={s.features_card}>
                                    <div className={s.title}>
                                        {t("page.feature three title")}
                                    </div>
                                    <div className={s.subtitle}>
                                        {t("page.feature three desc")}
                                    </div>
                                </div>
                                <div className={s.features_card}>
                                    <div className={s.title}>
                                        {t("page.feature four title")}
                                    </div>
                                    <div className={s.subtitle}>
                                        {t("page.feature four desc")}
                                    </div>
                                </div>
                            </div>

                            <div className={s.features_card_row}>
                                <div className={s.features_card}>
                                    <div className={s.title}>
                                        {t("page.feature five title")}
                                    </div>
                                    <div className={s.subtitle}>
                                        {t("page.feature five desc")}
                                    </div>
                                </div>
                                <div className={s.features_card}>
                                    <div className={s.title}>
                                        {t("page.feature six title")}
                                    </div>
                                    <div className={s.subtitle}>
                                        {t("page.feature six desc")}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className={s.planing_block}>
                        <div className={s.title}>
                            <span className={s.colorful}>Deep Seek AI </span> {t("page.plan")}
                        </div>

                        <div className={s.planing_cards_block}>
                            <div className={s.planing_cards_row}>
                                <div className={`${s.planing_card} ${s.gap}`}>
                                    <div className={s.planing_card_title}>
                                        {t("page.plan card one title")}
                                    </div>
                                    <div className={s.planing_card_desc}>
                                        {t("page.plan card one desc")}
                                    </div>
                                    <div className={s.absolute_block}>
                                        <div><img src={frame2} alt=""/></div>
                                        <div><img src={gateBig} alt=""/></div>
                                        <div><img src={BinanceBig} alt=""/></div>
                                        <div><img src={bybitBig} alt=""/></div>
                                    </div>
                                </div>
                                <div className={s.planing_card}>
                                    <div className={s.planing_card_title}>
                                        {t("page.plan card two title")}
                                    </div>
                                    <div className={s.planing_card_desc}>
                                        {t("page.plan card two desc")}
                                    </div>
                                </div>
                            </div>

                            <div className={s.planing_cards_row}>
                                <div className={s.planing_card}>
                                    <div className={s.planing_card_title}>
                                        {t("page.plan card three title")}
                                    </div>
                                    <div className={s.planing_card_desc}>
                                        {t("page.plan card three desc")}
                                    </div>
                                </div>
                                <div className={s.planing_card}>
                                    <div className={s.planing_card_title}>
                                        {t("page.plan card four title")}
                                    </div>
                                    <div className={s.planing_card_desc}>
                                        {t("page.plan card four desc")}
                                    </div>
                                </div>
                            </div>

                            <div className={s.planing_cards_row}>
                                <div className={s.planing_card}>
                                    <div className={s.planing_card_title}>
                                        {t("page.plan card five title")}
                                    </div>
                                    <div className={s.planing_card_desc}>
                                        {t("page.plan card five desc")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={s.join_us}>
                        {t("page.join one")} <span
                        className={s.colorful}>Deep Seek AI</span> {t("page.join two")}
                    </div>

                    <div className={s.contacts_block} id="contacts">
                        <div>
                            <div className={s.contacts_title}>
                                Contacts:
                            </div>
                            <div className={s.row}>
                                <img src={mail} alt=""/>
                                <span><a href="mailto:info@deepseeksol.com" target="_blank"
                                         className={s.mail_link}>info@deepseeksol.com</a></span>
                            </div>
                            <div className={s.row}>
                                <img src={baselineTelegram} alt=""/>
                                <span><a href="https://t.me/mrjns" target="_blank"
                                         className={s.mail_link}>@mrjns</a></span>
                            </div>
                        </div>
                        <div className={s.column}>
                            <div>
                                <a href="https://t.me/deepseekmain" target="_blank">
                                    <img src={telegramm} alt=""/>
                                </a>
                            </div>
                            <div>
                                <a href="https://t.me/deepseekAIchat" target="_blank">
                                    <img src={telegrammBlack} alt=""/>
                                </a>
                            </div>
                            <div>
                                <a href="https://x.com/deepseekmain" target="_blank">
                                    <img src={x} alt=""/>
                                </a>
                            </div>
                            <div>
                                <a href="https://discord.gg/mbGTETvw" target="_blank">
                                    <img src={discord} alt=""/>
                                </a>
                            </div>
                        </div>
                    </div>

                    <footer className={s.footer}>
                        <div className={s.footer_row}>
                            <div>
                                <a href="https://www.dextools.io/app/en/solana/pair-explorer/EUXDTw8d4ST47AmciKr5LUDCKaTmvkR8EJFxuh41dWzN?t=1738344146576"
                                   target="_blank" className={s.button_wrapper}>
                                    <button className={`${s.referal_button}`}>
                                        Watch how we grow on dextools.io
                                        <img className={s.referal_button_logo} src={dextools} alt=""/>
                                        <img src={arrow} alt=""/>
                                    </button>
                                </a>
                            </div>
                            <div>
                                <a href="https://dexscreener.com/solana/ChDvobtSkd933iLfy7VbznWyY8saes2nfN5jkaLppump"
                                   target="_blank" className={s.button_wrapper}>
                                    <button className={`${s.referal_button}`}>
                                        Watch how we grow on dexscreener.com
                                        <img className={s.referal_button_logo} src={dexsreener} alt=""/>
                                        <img src={arrow} alt=""/>
                                    </button>
                                </a>
                            </div>
                        </div>

                        <div className={s.footer_row}>
                            <div>
                                <a href="https://www.geckoterminal.com/solana/pools/EUXDTw8d4ST47AmciKr5LUDCKaTmvkR8EJFxuh41dWzN"
                                   target="_blank" className={s.button_wrapper}>
                                    <button className={`${s.referal_button}`}>
                                        Watch how we grow on geckoterminal.com
                                        <img className={s.referal_button_logo} src={gecko} alt=""/>
                                        <img src={arrow} alt=""/>
                                    </button>
                                </a>
                            </div>
                            <div>
                                <a href="https://coinmarketcap.com/dexscan/solana/7mKjMmJRuiLoGwGrewRdLKqBJXKGJL615bSDCW22f9Qo/"
                                   target="_blank" className={s.button_wrapper}>
                                    <button className={`${s.referal_button}`}>
                                        Watch how we grow on coinmarketcap.com
                                        <img className={s.referal_button_logo} src={coinmarket} alt=""/>
                                        <img src={arrow} alt=""/>
                                    </button>
                                </a>
                            </div>
                        </div>

                    </footer>

                </div>
            </div>
        </Suspense>
    );
}

export default App;
